// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   ThemeProvider,
//   createTheme
// } from '@mui/material';

// const SalaryPaymentMethod = () => {
//   const [openDialog, setOpenDialog] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState('');
//   const [paymentMethods, setPaymentMethods] = useState([]); // Data fetched from API

//   const options = {
//     selectableRows: "none",
//     selectToolbarPlacement: "none",
//     elevation: 0,
//     rowsPerPage: 5,
//     rowsPerPageOptions: [5, 10, 25, 100],
//     tableBody: {
//       style: {
//         maxHeight: "500px",
//         overflowY: "scroll",
//         marginLeft: "5PX",
//       },
//     },
//     tableHead: {
//       style: {
//         backgroundColor: "#f2f2f2",
//         color: "black",
//       },
//     },
//     rows: {
//       style: {
//         marginLeft: "5px",
//         textAlign: "center",
//       },
//       selectableRowsOnClick: true,
//     },
//   };

//   const getTheme = () =>
//     createTheme({
//       palette: {
//         mode: "light",
//         primary: {
//           main: "#2196f3",
//         },
//         secondary: {
//           main: "#03a9f4",
//         },
//       },
//       typography: {
//         fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
//       },
//     });

//   // Placeholder API integration functions
//   const fetchPaymentMethods = async () => {
//     // Call API to fetch payment methods and update the state
//     // Example: setPaymentMethods(await apiCall());
//   };

//   const addPaymentMethod = async (method) => {
//     // Call API to add a new payment method
//     // Example: await apiAddCall(method);
//   };

//   const editPaymentMethod = async (id, updatedMethod) => {
//     // Call API to edit a payment method
//   };

//   const deletePaymentMethod = async (id) => {
//     // Call API to delete a payment method
//   };

//   useEffect(() => {
//     fetchPaymentMethods();
//   }, []);

//   const handleOpenDialog = () => {
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setPaymentMethod('');
//   };

//   const handleAddPaymentMethod = async () => {
//     const newMethod = { methodName: paymentMethod };
//     await addPaymentMethod(newMethod); // Send data to API
//     await fetchPaymentMethods(); // Refresh data from API
//     handleCloseDialog();
//   };

//   return (
//     <ThemeProvider theme={getTheme()}>
//       <div style={{ padding: '20px' }}>
//         <Button variant="contained" color="primary" onClick={handleOpenDialog}>
//           Add New Salary Payment Method
//         </Button>

//         <TableContainer component={Paper} style={{ marginTop: '20px' }}>
//           <Table>
//             <TableHead style={options.tableHead.style}>
//               <TableRow>
//                 <TableCell>Method Name</TableCell>
//                 <TableCell>Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody style={options.tableBody.style}>
//               {paymentMethods.length > 0 ? (
//                 paymentMethods.map((method, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{method.methodName}</TableCell>
//                     <TableCell>
//                       <Button
//                         color="primary"
//                         onClick={() => editPaymentMethod(index, method)}
//                       >
//                         Edit
//                       </Button>
//                       <Button
//                         color="secondary"
//                         onClick={() => deletePaymentMethod(index)}
//                       >
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={2} align="center">
//                     - No payment methods added. -
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
//           <DialogTitle>Add New Salary Payment Method</DialogTitle>
//           <DialogContent>
//             <TextField
//               fullWidth
//               label="Salary Payment Method"
//               margin="normal"
//               value={paymentMethod}
//               onChange={(e) => setPaymentMethod(e.target.value)}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} color="secondary">
//               Cancel
//             </Button>
//             <Button onClick={handleAddPaymentMethod} color="primary" variant="contained">
//               Add
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </div>
//     </ThemeProvider>
//   );
// };

// export default SalaryPaymentMethod;
import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ThemeProvider,
  createTheme,
  AppBar
} from '@mui/material';
import { paymentMethodSettingsApi } from '../../../Data/axios';

const SalaryPaymentMethod = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [currentMethod, setCurrentMethod] = useState(null);

  const fetchPaymentMethods = async () => {
    try {
      const response = await paymentMethodSettingsApi.getAll();
      setPaymentMethods(response.data);
      console.log(response)
    } catch (error) {
      console.error("Error fetching payment methods:", error);
    }
  };

  const handleSavePaymentMethod = async () => {
    try {
      const formData = new FormData();
      formData.append("methodName", paymentMethod);

      if (currentMethod) {
        // Update existing payment method
        await paymentMethodSettingsApi.update(currentMethod.id, formData);
      } else {
        // Add new payment method
        await paymentMethodSettingsApi.add(formData);
      }

      fetchPaymentMethods(); 
      setOpenDialog(false);
      setPaymentMethod('');
      setCurrentMethod(null);
    } catch (error) {
      console.error("Error saving payment method:", error);
    }
  };

  const handleEditPaymentMethod = (method) => {
    setCurrentMethod(method);
    setPaymentMethod(method.methodName);
    setOpenDialog(true);
  };

  const handleDeletePaymentMethod = async (id) => {
    try {
      await paymentMethodSettingsApi.delete(id);
      fetchPaymentMethods();
    } catch (error) {
      console.error("Error deleting payment method:", error);
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
    });

  return (
    <ThemeProvider theme={getTheme()}>
      <div style={{ padding: '20px' }}>
        <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)}sx={{"&:hover": { backgroundColor: "orange" },}}>
          Add New Salary Payment Method
        </Button>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Method Name</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paymentMethods.length > 0 ? (
                paymentMethods.map((method) => (
                  <TableRow key={method.id}>
                    <TableCell>{method.methodName}</TableCell>
                    <TableCell>
                      <Button color="primary" onClick={() => handleEditPaymentMethod(method)} sx={{marginRight:"5px"}}variant="outlined">
                        Edit
                      </Button>
                      <Button color="secondary" onClick={() => handleDeletePaymentMethod(method.id)} variant="outlined">
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    - No payment methods added. -
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <DialogTitle sx={{color:"white"}}>{currentMethod ? 'Edit' : 'Add'} Salary Payment Method</DialogTitle>
        </AppBar>
          <DialogContent>
            <TextField
              fullWidth
              label="Salary Payment Method"
              margin="normal"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="secondary" sx={{color:"grey"}}>
              Cancel
            </Button>
            <Button onClick={handleSavePaymentMethod} color="primary" variant="contained" sx={{"&:hover": { backgroundColor: "orange" },}}>
              {currentMethod ? 'Update' : 'Add'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default SalaryPaymentMethod;
